import { LineType } from "../../../api.js";
import { vector_3 } from "../../../babylon/utility/Conversion.js";
import { rotate } from "../../../Math.js";
export class DebugVisualizer {
    constructor(viewer) {
        this._lines = [];
        this._is_enabled = true;
        this._line_manager = viewer.line_manager;
    }
    get is_enabled() {
        return this._is_enabled;
    }
    set is_enabled(v) {
        this._is_enabled = v;
    }
    dispose(start_index = 0) {
        this.remove_lines(start_index);
    }
    draw_line(index, p1, p2, color, line_thickness, line_type = LineType.SOLID) {
        if (!this.is_enabled)
            return;
        if (this._lines.length > index) {
            this._line_manager.update_line(this._lines[index], p1, p2, color, line_thickness);
        }
        else {
            this._lines.push(this._line_manager.create_line(line_type, p1, p2, color, line_thickness));
        }
    }
    draw_curve(index, start_point, end_point, main_axis, center, delta_angle, color, line_thickness, line_type = LineType.SOLID) {
        if (!this.is_enabled)
            return index;
        const num_segments = Math.round(delta_angle * 100);
        const points = [...Array(num_segments)].map((_, i) => rotate(start_point.subtract(center), -delta_angle * i / num_segments, main_axis));
        for (let i = 0; i < points.length; i++) {
            const point = vector_3(points[i]);
            if (i === points.length - 1) {
                this.draw_line(index + i, point.add(center), end_point, color, line_thickness, line_type);
            }
            else {
                this.draw_line(index + i, point.add(center), vector_3(points[i + 1]).add(center), color, line_thickness, line_type);
            }
        }
        return num_segments;
    }
    remove_lines(start_index = 0) {
        this._lines.slice(start_index).forEach(line => {
            this._line_manager.remove_line(line);
        });
        this._lines.splice(start_index);
    }
}
//# sourceMappingURL=DebugVisualizer.js.map